import styled from '@emotion/styled';
import React, {useContext, useState} from 'react';

import { Box } from '@mui/system';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@emotion/react';
import { Route, Routes, useNavigate,Navigate } from 'react-router-dom';
import RequireAuth from '../../components/RequireAuth';
import useAuth from '../../hooks/useAuth';
import StaffLoggerTable from '../../components/tables/1200/StaffLoggerTable';
import FunctionLogger from '../../components/tables/1200/FunctionLogger';

export default function Home() {
  const navigate=useNavigate();
  const DetailWrapper=styled(Box)(({theme})=>({
    display:"flex",
    flexWrap:'wrap',
    gap:"33px",
    margin:"20px",
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    paddingBottom:'44px',
    borderRadius:'2px',
  }))
  const InfoWrapper=styled(Box)({
    width:'100%',
    marginLeft:'10px',
    display:'flex',
    flexDirection:'column',
    gap:'10px',

  })
  const [table,setTable]=useState(window.location.pathname)
  const HandleChange = (event, newValue) => {
    setTable(newValue);
    navigate(newValue);
  };
  const {user}=useAuth();
  const {roles}=user
  return (
    <>
    <InfoWrapper>
      <Tabs
          value={table}
          onChange={HandleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
              fontFamily: 'Poppins',
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "18px",
          }}
        >
         {roles?.includes(1200) && <Tab value="/log" label="Staff Log" />}
         {roles?.includes(1201) &&  <Tab value="/log/functionality" label="Functionality Log" />}
         {/* {roles?.includes(1202) &&  <Tab value="/log/database" label="Database Log" />} */}
        </Tabs>
       <Routes>
        <Route element={<RequireAuth allowedRoles={[1200]} />}>
          <Route
            exact
            index
            element={<StaffLoggerTable />}
          />
        </Route>
          <Route element={<RequireAuth allowedRoles={[1201]} />}>
          <Route
            exact
            path="/functionality"
            element={<FunctionLogger />}
          />
        </Route>
      </Routes>  
    </InfoWrapper>
  
    
    </>
  )
}
